import axios from "axios"
import { FACEBOOK_CREATIVES_URL } from "src/constants"

export const updateCreative = async (creativeId, updateData) => {
  const response = await axios.patch(`${FACEBOOK_CREATIVES_URL}/${creativeId}`, updateData)
  return response.data
}
